import { getRepresentativeFromParticipant } from 'modules/boards/utils';
import {
  Board,
  BoardParticipant,
  Partner,
  PartnerRepresentant,
  Society,
} from 'types';

import { getParticipantShares } from '../../BoardAttendance/utils/getParticipantShares';
import { getParticipantPercent } from '../../BoardAttendance/utils/getParticipantPercent';
import { getParticipantAttendance } from './getParticipantAttendance';

export type BoardAssistant = Partial<BoardParticipant> & {
  participantNumber: number;
  participantMemberId: string;
  participantName: string;
  representative: Partner | PartnerRepresentant | undefined;
  representativeName: string;
  percentage: number;
  shares: number;
  societyId: string;
  attend: string;
  decimals: number;
};

type GetBoardAssistantsProps = {
  actualSociety: Society;
  board: Board;
  partners: Partner[];
  partnerRepresentants: PartnerRepresentant[];
};

const getBoardAssistants = ({
  actualSociety,
  board,
  partners,
  partnerRepresentants,
}: GetBoardAssistantsProps): BoardAssistant[] =>
  board.participants.map((participant: BoardParticipant, index: number) => {
    const representative = getRepresentativeFromParticipant(
      participant,
      partners,
      partnerRepresentants
    );

    const sharesCount = getParticipantShares({
      board,
      participant,
      partners,
    });

    const percentage = getParticipantPercent({
      board,
      actualSociety,
      participant,
      partners,
    });

    const attend = getParticipantAttendance(participant);

    return {
      ...participant,
      participantNumber: index + 1,
      participantMemberId: participant?.member,
      participantName: participant?.name,
      representative,
      representativeName: representative?.name || '-',
      percentage,
      shares: sharesCount,
      societyId: actualSociety['_id'],
      attend,
      decimals: 3,
    };
  });

export default getBoardAssistants;
